import { isNumber } from "@thi.ng/checks";
export function mapVectors(fn, out, a, b, c) {
    const num = a.length;
    !out && (out = new Array(num));
    if (c !== undefined) {
        if (isNumber(c)) {
            for (let i = 0; i < num; i++) {
                out[i] = fn(out[i] || [], a[i], b[i], c);
            }
        }
        else {
            for (let i = 0; i < num; i++) {
                out[i] = fn(out[i] || [], a[i], b[i], c[i]);
            }
        }
    }
    else {
        if (isNumber(b)) {
            for (let i = 0; i < num; i++) {
                out[i] = fn(out[i] || [], a[i], b);
            }
        }
        else {
            for (let i = 0; i < num; i++) {
                out[i] = fn(out[i] || [], a[i], b[i]);
            }
        }
    }
    return out;
}
